module.exports = __webpack_public_path__ + "images/f2aabc6.png";